import React from 'react';
import '../styles/Contact.css';

const AdminContact = () => {
  const messages = [
    { name: 'John Doe', email: 'john@email.com', service: 'Electrical Installation', date: 'April 15, 2026' },
    { name: 'Jane Smith', email: 'jane@email.com', service: 'Solar Systems', date: 'April 14, 2026' },
    { name: 'Peter Kamau', email: 'peter@email.com', service: 'CCTV Installation', date: 'April 13, 2026' },
    { name: 'Mary Wanjiku', email: 'mary@email.com', service: 'Network Setup', date: 'April 12, 2026' }
  ];
  return (
    <div className="contact-page">
      <h1>Contact Messages</h1>
      <p>View and manage contact form submissions.</p>
      <table className="contact-table">
        <thead><tr><th>#</th><th>Name</th><th>Email</th><th>Service</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>{messages.map((m,i)=>(<tr key={i}><td>{i+1}</td><td>{m.name}</td><td>{m.email}</td><td>{m.service}</td><td>{m.date}</td><td><button className="view-btn">View</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminContact;
